"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setVal = void 0;
var set_deleteVal_1 = require("./utils/set_deleteVal");
var setVal = function (data, valuePath, value) {
    return (0, set_deleteVal_1.set_deleteVal)('set', data, valuePath, value);
};
exports.setVal = setVal;
